import {ADD_ACTIVITY, ADD_ACTIVITIES, CLEAR_ACTIVITIES, REMOVE_ACTIVITY, SET_ACTIVITY_VIEW, SET_ACTIVITY_QUERY} from "../actionTypes";
import {apiGet} from "../../Api";

export function addActivity(activity) {
  return {
    type: ADD_ACTIVITY,
    payload: activity
  }
}

export function removeActivity(activity) {
  return {
    type: REMOVE_ACTIVITY,
    payload: activity
  }
}

export function addActivities(activities) {
  return (dispatch) => {
    let resActivities = [];
    activities.forEach( (activity, i) => {
      apiGet(`/node/activity/${activity.id}?include=field_banner_image,field_experience_layer,field_course_phase,field_activity_type,field_materials,field_video&jsonapi_include=1`)
        .then( res => {
          resActivities.push(res.data.data);
          if (resActivities.length === activities.length) {
            dispatch({
              type: ADD_ACTIVITIES,
              payload: resActivities
            })
          }
        })
    })
  }
}

export function clearActivities() {
  return {
    type: CLEAR_ACTIVITIES
  }
}

export function setActivityView(view) {
  return {
    type: SET_ACTIVITY_VIEW,
    payload: view
  }
}

export function setActivityQuery(query) {
  // console.log("REDUX ACTION:"  + query)
  return {
    type: SET_ACTIVITY_QUERY,
    payload: query
  }
}
